import styled from 'styled-components';

export const Content = styled.div`
  padding: 20px;
  box-sizing: border-box;
  }
`;

export const WrapMessage = styled.div`
  width: 100%;
  gap: 20px;
  margin: 0 0 20px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: white;
`;

export const Buttons = styled.div`
  justify-content: space-between;
  display: flex;
`;

export const Button = styled.button`
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #eee;
  border-radius: 10px;
  padding: 0 15px;
  border: 0;
  cursor: pointer;
  background: #48515b;
  margin: 0;
  position: relative;
  transition: 0.3s all ease-in;
  &:hover {
    background: #28313b;
  }
`;
